export default __webpack_public_path__ + "static/media/ge_square.5f1d8efc.svg";